export const months = [
    { label: 'jan', days: 31 },
    { label: 'feb', days: 28 },
    { label: 'mar', days: 31 },
    { label: 'apr', days: 30 },
    { label: 'may', days: 31 },
    { label: 'jun', days: 30 },
    { label: 'jul', days: 31 },
    { label: 'aug', days: 31 },
    { label: 'sep', days: 30 },
    { label: 'oct', days: 31 },
    { label: 'nov', days: 30 },
    { label: 'dec', days: 31 },
];

export const dogs = [
    { 
        label: 'Good dog',
        img: require('../images/000.jpg'),
        smallImg: require('../images/small/000.jpg'),
        download: require('../images/download/000.jpg')
    },
    { 
        label: 'Mop dog',
        img: require('../images/001.jpg'),
        smallImg: require('../images/small/001.jpg'),
        download: require('../images/download/001.jpg')
    },
    { 
        label: 'Chic dog',
        img: require('../images/002.jpg'),
        smallImg: require('../images/small/002.jpg'),
        download: require('../images/download/002.jpg')
    },
    { 
        label: 'Hot dog #1',
        img: require('../images/003.jpg'),
        smallImg: require('../images/small/003.jpg'),
        download: require('../images/download/003.jpg')
    },
    { 
        label: 'Fluffy dog',
        img: require('../images/004.jpg'),
        smallImg: require('../images/small/004.jpg'),
        download: require('../images/download/004.jpg')
    },
    { 
        label: 'Satisfied dog',
        img: require('../images/005.jpg'),
        smallImg: require('../images/small/005.jpg'),
        download: require('../images/download/005.jpg')
    },
    { 
        label: 'Handbag dog',
        img: require('../images/006.jpg'),
        smallImg: require('../images/small/006.jpg'),
        download: require('../images/download/006.jpg')
    },
    { 
        label: 'Hoody dog',
        img: require('../images/007.jpg'),
        smallImg: require('../images/small/007.jpg'),
        download: require('../images/download/007.jpg')
    },
    { 
        label: 'Illusion dog',
        img: require('../images/008.jpg'),
        smallImg: require('../images/small/008.jpg'),
        download: require('../images/download/008.jpg')
    },
    { 
        label: 'Geometric dog',
        img: require('../images/009.jpg'),
        smallImg: require('../images/small/009.jpg'),
        download: require('../images/download/009.jpg')
    },
    { 
        label: 'Pixel dog',
        img: require('../images/010.jpg'),
        smallImg: require('../images/small/010.jpg'),
        download: require('../images/download/010.jpg')
    },
    { 
        label: 'Influencer dog',
        img: require('../images/011.jpg'),
        smallImg: require('../images/small/011.jpg'),
        download: require('../images/download/011.jpg')
    },
    { 
        label: 'Left hand dog',
        img: require('../images/012.jpg'),
        smallImg: require('../images/small/012.jpg'),
        download: require('../images/download/012.jpg')
    },
    { 
        label: 'Stereoscopic dog',
        img: require('../images/013.jpg'),
        smallImg: require('../images/small/013.jpg'),
        download: require('../images/download/013.jpg')
    },
    { 
        label: 'Artist dog',
        img: require('../images/014.jpg'),
        smallImg: require('../images/small/014.jpg'),
        download: require('../images/download/014.jpg')
    },
    { 
        label: 'Isle of dog',
        img: require('../images/015.jpg'),
        smallImg: require('../images/small/015.jpg'),
        download: require('../images/download/015.jpg')
    },
    { 
        label: 'Shy dog',
        img: require('../images/016.jpg'),
        smallImg: require('../images/small/016.jpg'),
        download: require('../images/download/016.jpg')
    },
    { 
        label: 'Cartoon dog #1',
        img: require('../images/017.jpg'),
        smallImg: require('../images/small/017.jpg'),
        download: require('../images/download/017.jpg')
    },
    { 
        label: 'Skate dog',
        img: require('../images/018.jpg'),
        smallImg: require('../images/small/018.jpg'),
        download: require('../images/download/018.jpg')
    },
    { 
        label: 'Sea dog',
        img: require('../images/019.jpg'),
        smallImg: require('../images/small/019.jpg'),
        download: require('../images/download/019.jpg')
    },
    { 
        label: 'Pastel dog',
        img: require('../images/020.jpg'),
        smallImg: require('../images/small/020.jpg'),
        download: require('../images/download/020.jpg')
    },
    { 
        label: 'Chill dog',
        img: require('../images/021.jpg'),
        smallImg: require('../images/small/021.jpg'),
        download: require('../images/download/021.jpg')
    },
    { 
        label: 'French dog',
        img: require('../images/022.jpg'),
        smallImg: require('../images/small/022.jpg'),
        download: require('../images/download/022.jpg')
    },
    { 
        label: 'Petsu dog',
        img: require('../images/023.jpg'),
        smallImg: require('../images/small/023.jpg'),
        download: require('../images/download/023.jpg')
    },
    { 
        label: 'Blonde dog',
        img: require('../images/024.jpg'),
        smallImg: require('../images/small/024.jpg'),
        download: require('../images/download/024.jpg')
    },
    { 
        label: 'Picasso jake dog',
        img: require('../images/025.jpg'),
        smallImg: require('../images/small/025.jpg'),
        download: require('../images/download/025.jpg')
    },
    { 
        label: 'Astro dog',
        img: require('../images/026.jpg'),
        smallImg: require('../images/small/026.jpg'),
        download: require('../images/download/026.jpg')
    },
    { 
        label: 'Meanies dog',
        img: require('../images/027.jpg'),
        smallImg: require('../images/small/027.jpg'),
        download: require('../images/download/027.jpg')
    },
    { 
        label: 'Crowdsourced dog',
        img: require('../images/028.jpg'),
        smallImg: require('../images/small/028.jpg'),
        download: require('../images/download/028.jpg')
    },
    { 
        label: 'Birthday dog',
        img: require('../images/029.jpg'),
        smallImg: require('../images/small/029.jpg'),
        download: require('../images/download/029.jpg')
    },
    { 
        label: 'Wall dog',
        img: require('../images/030.jpg'),
        smallImg: require('../images/small/030.jpg'),
        download: require('../images/download/030.jpg')
    },
    { 
        label: 'Busy dog',
        img: require('../images/031.jpg'),
        smallImg: require('../images/small/031.jpg'),
        download: require('../images/download/031.jpg')
    },
    { 
        label: 'Txt dog',
        img: require('../images/032.jpg'),
        smallImg: require('../images/small/032.jpg'),
        download: require('../images/download/032.jpg')
    },
    { 
        label: 'Crayon dog',
        img: require('../images/033.jpg'),
        smallImg: require('../images/small/033.jpg'),
        download: require('../images/download/033.jpg')
    },
    { 
        label: 'Hound dog',
        img: require('../images/034.jpg'),
        smallImg: require('../images/small/034.jpg'),
        download: require('../images/download/034.jpg')
    },
    { 
        label: 'Love dog',
        img: require('../images/035.jpg'),
        smallImg: require('../images/small/035.jpg'),
        download: require('../images/download/035.jpg')
    },
    { 
        label: 'Plane dog',
        img: require('../images/036.jpg'),
        smallImg: require('../images/small/036.jpg'),
        download: require('../images/download/036.jpg')
    },
    { 
        label: 'Hot dog #2',
        img: require('../images/037.jpg'),
        smallImg: require('../images/small/037.jpg'),
        download: require('../images/download/037.jpg')
    },
    { 
        label: 'Zine dog',
        img: require('../images/038.jpg'),
        smallImg: require('../images/small/038.jpg'),
        download: require('../images/download/038.jpg')
    },
    { 
        label: 'Inktober dog',
        img: require('../images/039.jpg'),
        smallImg: require('../images/small/039.jpg'),
        download: require('../images/download/039.jpg')
    },
    { 
        label: 'Helpful dog',
        img: require('../images/040.jpg'),
        smallImg: require('../images/small/040.jpg'),
        download: require('../images/download/040.jpg')
    },
    { 
        label: 'Swiss dog',
        img: require('../images/041.jpg'),
        smallImg: require('../images/small/041.jpg'),
        download: require('../images/download/041.jpg')
    },
    { 
        label: 'Missing dog',
        img: require('../images/042.jpg'),
        smallImg: require('../images/small/042.jpg'),
        download: require('../images/download/042.jpg')
    },
    { 
        label: 'Spooky dog',
        img: require('../images/043.jpg'),
        smallImg: require('../images/small/043.jpg'),
        download: require('../images/download/043.jpg')
    },
    { 
        label: 'Cartoon dog #2',
        img: require('../images/044.jpg'),
        smallImg: require('../images/small/044.jpg'),
        download: require('../images/download/044.jpg')
    },
    { 
        label: 'Dodgy dog',
        img: require('../images/045.jpg'),
        smallImg: require('../images/small/045.jpg'),
        download: require('../images/download/045.jpg')
    },
    { 
        label: 'Leaving dog',
        img: require('../images/046.jpg'),
        smallImg: require('../images/small/046.jpg'),
        download: require('../images/download/046.jpg')
    },
    { 
        label: 'Future dog',
        img: require('../images/047.jpg'),
        smallImg: require('../images/small/047.jpg'),
        download: require('../images/download/047.jpg')
    },
    { 
        label: 'Idea dog',
        img: require('../images/048.jpg'),
        smallImg: require('../images/small/048.jpg'),
        download: require('../images/download/048.jpg')
    },
    { 
        label: 'Wire dog',
        img: require('../images/049.jpg'),
        smallImg: require('../images/small/049.jpg'),
        download: require('../images/download/049.jpg')
    },
    { 
        label: 'Advent dog',
        img: require('../images/050.gif'),
        smallImg: require('../images/small/050.jpg'),
        download: require('../images/download/050.jpg')
    },
    { 
        label: 'Present dog',
        img: require('../images/052.jpg'),
        smallImg: require('../images/small/052.jpg'),
        download: require('../images/download/051.jpg')
    },
];